import { ComponentConfig, FieldLabel } from '@measured/puck';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../services/constants';
import CustomTooltip from '../../../components/common/tooltip';
import {
  setIsCartLoading,
  setCartData,
} from '../../../page-builder/redux/slices/cartSlice';
import { setCheckoutErrorMessage } from '../../../page-builder/redux/slices/commonSlice';
import { setAvailableShippingMethods } from '../../../page-builder/redux/slices/checkoutSlice';
import './../text-editor/style.scss';
import {
  getBorderProps,
  getcurrentDeviceType,
  getFontSize,
  getMarginStyles,
  getNewMarginStyles,
  getPaddingStyles,
} from '../../utils/helper';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import { AxiosInstance } from 'axios';
import { useCallback, useEffect, useRef, useState } from 'react';
import { IProductVariant } from '../../interface/storeInterface';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import { getIsEdit, toolTipInfo } from '../../utils/constants';
import checkoutService from '../../api/checkoutService';
import { marginFields, MarginProps } from '../../puck/reusable-props/margin';
import {
  paddingFields,
  PaddingProps,
  PaddingType,
} from '../../puck/reusable-props/padding';
import '../shipment-upsells/style.scss';
import { imageField } from '../../puck/reusable-props/image';
import {
  AddItemPayload,
  IAsset,
  CheckoutUpdateItemsPayload,
} from '../../interface/apiServiceInterface';
import { QuillTextEditor } from '../../puck/reusable-props/quill-editor';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';
import { ShippingMethod, UpSellData } from '../../interface/checkoutInterface';
import TextCustomInput from '../../puck/reusable-props/TextCustomInput';
import { CustomizeProps } from '../../interface/commonInterface';
import WithAccordion from '../customComponents/CustomAccordion';
import { ToggleButtonGroup, ToggleButton, Switch } from '@mui/material';
import QuillFieldRenderer from '../carousel review/QuillFieldRenderer';
import WidthAndHeight, {
  WidthAndHeightSubProps,
} from '../../puck/reusable-props/widthAndHeight';
import PaddingComponent from '../customComponents/PaddingComponent';
import { MarginType } from '../../puck/reusable-props/NewMargin';
import NewMarginFiled from '../../puck/reusable-props/newMarginField';
import BackgroungColorComponent, {
  IBackgroundProps,
} from '../customComponents/BackgroungColorComponent';
import SelectProduct, { CartProductsProps } from './SelectProduct';

export type GiftProductTimerProps = {
  imageFile: IAsset;
  selectProductForUpGift: CartProductsProps | null;
  border: IBorderValueProps;
  showImage: boolean;
  background: {
    color: string;
    isInherit: boolean;
  };
  countDown: CustomizeProps;
  customCountDown: {
    addHours: boolean;
    addMSeconds: boolean;
  };
  imageCustamize: {
    imageSizeControl: WidthAndHeightSubProps;
    imagePadding: PaddingType;
    imageBorder: IBorderValueProps;
    imageMargin: MarginType;
  };
  badgeCustomization: {
    showBadge: boolean;
    badgeText: string;
    badgeColor: IBackgroundProps;
  };
  customLabels: {
    hours: string;
    minutes: string;
    seconds: string;
    milliseconds: string;
    showLabels: boolean;
  };
  interval: number;
  timerSuffix: string;
  text: string;
} & showComponentProps &
  MarginProps &
  PaddingProps;

export const GiftProductTimer = ({
  useAppSelector,
  useAppDispatch,
  baseService,
}: ReduxSelectorProps & {
  baseService: AxiosInstance;
} & ReduxDispatchProps): ComponentConfig<GiftProductTimerProps> => {
  return {
    label: (
      <CustomTooltip title="Gift Product Timer">
        <span>Gift Product Timer</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      showImage: {
        type: 'radio',
        label: 'Show Image',
        options: [
          {
            label: 'Yes',
            value: true,
          },
          {
            label: 'No',
            value: false,
          },
        ],
      },
      imageFile: { ...imageField(true, baseService).file },
      imageCustamize: {
        type: 'custom',
        label: 'Image Customize',
        render: ({ value, onChange }) => {
          return (
            <>
              <WithAccordion title="Image Customization">
                <WidthAndHeight
                  value={value?.imageSizeControl}
                  onChange={val => {
                    onChange({
                      ...value,
                      imageSizeControl: val,
                    });
                  }}
                  title={'Image Size Control'}
                />
                <NewMarginFiled
                  value={value.imageMargin}
                  onChange={val => {
                    onChange({
                      ...value,
                      imageMargin: val,
                    });
                  }}
                  title="Image Margin"
                />
                <PaddingComponent
                  value={value.imagePadding}
                  onChange={val => {
                    onChange({
                      ...value,
                      imagePadding: val,
                    });
                  }}
                  title="Image Padding"
                />
                <Border
                  value={value.imageBorder}
                  onChange={val => {
                    onChange({
                      ...value,
                      imageBorder: val,
                    });
                  }}
                  title="Image Border"
                />
              </WithAccordion>
            </>
          );
        },
      },
      badgeCustomization: {
        type: 'custom',
        label: 'Badge Customization',
        render: ({ value, onChange }) => (
          <WithAccordion title="Badge Customization">
            <div className="flex flex-col gap-2">
              <div className="flex justify-between items-center">
                <label>Show Badge</label>
                <Switch
                  checked={value?.showBadge}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      showBadge: selectedValue,
                    });
                  }}
                />
              </div>
              <QuillFieldRenderer
                label="Badge Text"
                value={value.badgeText}
                onChange={val => onChange({ ...value, badgeText: val })}
                id={7}
              />
              <BackgroungColorComponent
                value={value.badgeColor}
                onChange={badgeColor => onChange({ ...value, badgeColor })}
              />
            </div>
          </WithAccordion>
        ),
      },
      selectProductForUpGift: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <SelectProduct
            baseService={baseService}
            value={value}
            onChange={value => {
              onChange(value);
            }}
            useAppSelector={useAppSelector}
          />
        ),
      },
      countDown: {
        type: 'custom',
        label: 'Count Down',
        render: ({ value, onChange }) => (
          <TextCustomInput
            showComponent={true}
            title="Count Down"
            isText={false}
            value={value}
            onChange={onChange}
          />
        ),
      },
      customCountDown: {
        type: 'custom',
        label: 'Custom Countdown',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Custom Countdown">
              <>
                {/* Add Hours Option */}
                <div>
                  <FieldLabel
                    label={
                      (
                        <CustomTooltip
                          title={
                            'Include Hours in Countdown' as keyof typeof toolTipInfo
                          }>
                          <span>Include Hours</span>
                        </CustomTooltip>
                      ) as React.ReactNode as string
                    }
                    el="div"
                    className="w-full">
                    <div className="w-full p-2">
                      <ToggleButtonGroup
                        value={value?.addHours}
                        exclusive
                        className="w-full"
                        onChange={(_e, selectedValue) => {
                          if (selectedValue !== null) {
                            onChange({ ...value, addHours: selectedValue });
                          }
                        }}>
                        {[
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ].map((option, index) => (
                          <ToggleButton
                            key={index}
                            size="small"
                            value={option.value}
                            disableRipple
                            aria-label={option.label}
                            className="flex-1">
                            {option.label}
                          </ToggleButton>
                        ))}
                      </ToggleButtonGroup>
                    </div>
                  </FieldLabel>
                </div>

                {/* Add Milliseconds Option */}
                <div>
                  <FieldLabel
                    label={
                      (
                        <CustomTooltip
                          title={
                            'Include Milliseconds in Countdown' as keyof typeof toolTipInfo
                          }>
                          <span>Include Milliseconds</span>
                        </CustomTooltip>
                      ) as React.ReactNode as string
                    }
                    el="div"
                    className="w-full">
                    <div className="w-full p-2">
                      <ToggleButtonGroup
                        value={value?.addMSeconds}
                        exclusive
                        className="w-full"
                        onChange={(_e, selectedValue) => {
                          if (selectedValue !== null) {
                            onChange({ ...value, addMSeconds: selectedValue });
                          }
                        }}>
                        {[
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ].map((option, index) => (
                          <ToggleButton
                            key={index}
                            size="small"
                            value={option.value}
                            disableRipple
                            aria-label={option.label}
                            className="flex-1">
                            {option.label}
                          </ToggleButton>
                        ))}
                      </ToggleButtonGroup>
                    </div>
                  </FieldLabel>
                </div>
              </>
            </WithAccordion>
          );
        },
      },
      customLabels: {
        type: 'custom',
        label: 'Customize Timer Label',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Custom Labels">
              <QuillFieldRenderer
                label="Hours Label"
                value={value.hours}
                onChange={val => onChange({ ...value, hours: val })}
                id={1}
              />
              <QuillFieldRenderer
                label="Minutes Label"
                value={value.minutes}
                onChange={val => onChange({ ...value, minutes: val })}
                id={2}
              />
              <QuillFieldRenderer
                label="Seconds Label"
                value={value.seconds}
                onChange={val => onChange({ ...value, seconds: val })}
                id={3}
              />
              <QuillFieldRenderer
                label="MilliSeconds Label"
                value={value.milliseconds}
                onChange={val => onChange({ ...value, milliseconds: val })}
                id={4}
              />
              <div className="flex justify-between items-center mb-3">
                <label>Show Label</label>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.showLabels}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      showLabels: selectedValue,
                    });
                  }}
                />
              </div>
            </WithAccordion>
          );
        },
      },
      interval: { type: 'number', label: 'Interval', min: 0 },
      timerSuffix: {
        ...QuillTextEditor('Timer Suffix', true, 5).content,
      },
      text: {
        ...QuillTextEditor('Text Content', true, 6).content,
      },
      ...backgroungFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      ...marginFields,
      ...paddingFields,
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      selectProductForUpGift: null,
      border: {
        deviceType: 'desktop',
        borderBottomLeft: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderBottomRight: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderTopLeft: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderTopRight: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderWidth: {
          desktop: 1,
          tablet: 1,
          mobile: 1,
        },
        borderStyle: {
          desktop: 'border-solid',
          tablet: 'border-solid',
          mobile: 'border-solid',
        },
        borderColor: {
          desktop: '#c1c2c8',
          tablet: '#c1c2c8',
          mobile: '#c1c2c8',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '10',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '10',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '10',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '10',
          mobile: '0',
          tablet: '0',
        },
      },
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      showImage: true,
      imageFile: {
        storeID: '',
        fileName: 'logo',
        imageUrl: '',
      },
      imageCustamize: {
        imageSizeControl: {
          height: {
            desktop: '100',
            mobile: '100',
            tablet: '100',
          },
          maxWidth: {
            desktop: '100',
            mobile: '100',
            tablet: '100',
          },
          deviceType: 'desktop',
        },
        imagePadding: {
          deviceType: 'desktop',
          paddingBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '',
          },
          paddingRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
        imageBorder: borderProps.border,
        imageMargin: {
          deviceType: 'desktop',
          marginBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
      },
      badgeCustomization: {
        showBadge: true,
        badgeText: '<span style="font-size: 16px;">EXCLUSIVE FREE GIFT</span>',
        badgeColor: {
          isInherit: false,
          color: '#000000',
        },
      },
      countDown: {
        timerGap: '0',
        weight: {
          mobile: 'font-bold',
          tablet: 'font-bold',
          desktop: 'font-bold',
        },
        showComponent: {
          mobile: true,
          tablet: true,
          desktop: true,
        },
        deviceType: 'desktop',
        text: '',
        textColor: {
          mobile: '#FF0000',
          tablet: '#FF0000',
          desktop: '#FF0000',
        },
        fontSize: {
          mobile: 'text-[32px]',
          tablet: 'text-[32px]',
          desktop: 'text-[32px]',
        },
      },
      customCountDown: {
        addHours: false,
        addMSeconds: false,
      },
      customLabels: {
        hours: '<span style="font-size: 20px;">HH</span>',
        minutes: '<span style="font-size: 20px;">MM</span>',
        seconds: '<span style="font-size: 20px;">SS</span>',
        milliseconds: '<span style="font-size: 20px;">MS</span>',
        showLabels: false,
      },
      interval: 10 * 60,
      timerSuffix: '',
      text: '<span style="font-size: 18px;">Get a FREE Gift when you order in the next 5 minutes!</span>',
    },
    render: ({
      showComponent,
      border,
      imageCustamize,
      selectProductForUpGift,
      margin,
      padding,
      imageFile,
      showImage,
      editMode,
      background,
      text,
      interval,
      customCountDown,
      countDown,
      customLabels,
      timerSuffix,
      badgeCustomization,
    }) => {
      const dispatch = useAppDispatch();
      const { storeData, currentWidth } = useAppSelector(state => state.store);
      const currentDeviceType = getcurrentDeviceType(currentWidth, editMode);
      const { cartData } = useAppSelector(state => state.cart);
      const { pageId } = useAppSelector(state => state.checkout);
      const [time, setTime] = useState(interval * 1000);
      const [timerActive, setTimerActive] = useState(true);
      const [hasRemoved, setHasRemoved] = useState(false);
      const [isAddedByComponent, setIsAddedByComponent] = useState(false);
      const [isRemovedByUser, setIsRemovedByUser] = useState(false);
      const [initialCartChecked, setInitialCartChecked] = useState(false);
      const url = process.env.REACT_APP_S3_BUCKET_URL + imageFile.imageUrl;
      const marginStyles = getMarginStyles(margin, currentDeviceType);

      const variantId = selectProductForUpGift?.variant?.id;
      const isInCartInitially = useRef(false);

      useEffect(() => {
        if (!initialCartChecked && variantId && cartData?.LineItems) {
          const exists = cartData.LineItems.some(item =>
            item.VariantID.includes(String(variantId)),
          );
          isInCartInitially.current = exists;
          setInitialCartChecked(true);
        }
      }, [variantId, cartData?.LineItems]);

      useEffect(() => {
        if (
          initialCartChecked &&
          !isInCartInitially.current &&
          !hasRemoved &&
          !getIsEdit()
        ) {
          handleAdd();
          setIsAddedByComponent(true);
        }
      }, [initialCartChecked]);

      useEffect(() => {
        if (!timerActive || hasRemoved || !isAddedByComponent) return;

        const intervalId = setInterval(() => {
          setTime(prev => {
            if (prev > 0) return prev - 10;
            clearInterval(intervalId);
            setTimerActive(false);
            return 0;
          });
        }, 10);

        return () => clearInterval(intervalId);
      }, [timerActive, hasRemoved, isAddedByComponent]);

      useEffect(() => {
        if (time === 0 && isAddedByComponent && !hasRemoved) {
          handleRemove().then(() => setHasRemoved(true));
        }
      }, [time]);

      const handleAdd = useCallback(async () => {
        if (!variantId || !cartData?.ID) return;
        dispatch(setIsCartLoading(true));
        const lineItems = [
          {
            Quantity: 1,
            VariantID: `gid://shopify/ProductVariant/${variantId}`,
          },
        ];

        const payload: AddItemPayload = {
          ID: cartData?.ID,
          LineItems: lineItems,
          ShopID: storeData?.ShopID,
          StoreID: Number(storeData?.StoreID),
          PageID: String(pageId) || '',
        };

        try {
          const res = await checkoutService.checkoutAddItem(payload, {
            preUpsellData: [
              {
                ID: `gid://shopify/Product/${variantId}`,
                ImageURL: selectProductForUpGift?.product?.image?.src || '',
                Title: selectProductForUpGift?.product?.title || '',
                Variants: (selectProductForUpGift?.product?.variants || []).map(
                  (variant: IProductVariant) => ({
                    ID: `gid://shopify/ProductVariant/${variant.id}`,
                    ImageURL: selectProductForUpGift?.product?.image?.src || '',
                    OriginalPrice: variant.price || 0,
                    Price: variant.price || 0,
                    Title: variant.title || '',
                  }),
                ),
                CurrencyCode: 'USD',
              },
            ] as unknown as UpSellData,
            cartData,
          });

          if (res?.data?.Cart) {
            dispatch(setCartData(res.data.Cart));
            dispatch(
              setAvailableShippingMethods(
                res.data.Cart.AvailableShippingMethods as ShippingMethod[],
              ),
            );
          }
        } catch (error) {
          if (error instanceof Error) {
            dispatch(setCheckoutErrorMessage(error.message));
          }
        } finally {
          dispatch(setIsCartLoading(false));
        }
      }, [cartData, variantId]);

      // Remove item from cart
      const handleRemove = useCallback(async () => {
        dispatch(setIsCartLoading(true));

        try {
          const lineItem = cartData?.LineItems.find(item =>
            item.VariantID.includes(String(variantId)),
          );
          if (!lineItem) return;

          const lineItems = [
            {
              ID: lineItem.ID,
              Quantity: 0,
              VariantID: lineItem.VariantID,
            },
          ];

          const payload = {
            ID: cartData?.ID,
            LineItems: lineItems,
            ShopID: storeData?.ShopID,
            StoreID: Number(storeData?.StoreID),
            PageID: String(pageId) || '',
          };

          const res = await checkoutService.checkoutUpdateItems(
            payload as CheckoutUpdateItemsPayload,
            cartData,
          );
          dispatch(setCartData(res.data.Cart));
          dispatch(
            setAvailableShippingMethods(
              res.data.Cart.AvailableShippingMethods as ShippingMethod[],
            ),
          );
        } catch (error) {
          if (error instanceof Error) {
            dispatch(setCheckoutErrorMessage(error.message));
          }
        } finally {
          dispatch(setIsCartLoading(false));
        }
      }, [cartData]);

      useEffect(() => {
        const exists = cartData?.LineItems.some(item =>
          item.VariantID.includes(String(variantId)),
        );

        if (isAddedByComponent && !exists) {
          setIsRemovedByUser(true);
        }
      }, [cartData, variantId]);

      if (
        (initialCartChecked && isInCartInitially.current) ||
        (isRemovedByUser && isAddedByComponent)
      ) {
        return <></>;
      }

      const hours = Math.floor(time / 3600000);
      const minutes = Math.floor((time % 3600000) / 60000);
      const seconds = Math.floor((time % 60000) / 1000);
      const milliseconds = Math.floor((time % 1000) / 10);
      const timerGap = getFontSize(countDown?.timerGap);
      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              style={{
                ...getBorderProps(border, currentDeviceType),
                ...marginStyles,
                ...getPaddingStyles(padding, currentDeviceType),
                backgroundColor: background?.isInherit
                  ? 'inherit'
                  : background?.color,
              }}
              className={`overflow-hidden text-editor-content transition-all ease-in-out flex gap-2 ${border?.borderStyle?.[currentDeviceType]}`}>
              <div className="grid place-items-center">
                {showImage && (
                  <>
                    <div style={{ position: 'relative' }}>
                      <img
                        style={{
                          ...getNewMarginStyles(
                            imageCustamize?.imageMargin,
                            currentDeviceType,
                          ),
                          ...getPaddingStyles(
                            imageCustamize?.imagePadding,
                            currentDeviceType,
                          ),
                          ...(imageCustamize?.imageBorder && currentDeviceType
                            ? getBorderProps(
                                imageCustamize?.imageBorder,
                                currentDeviceType,
                              )
                            : {}),
                          ...(currentDeviceType &&
                          imageCustamize?.imageSizeControl?.maxWidth &&
                          imageCustamize?.imageSizeControl?.height &&
                          imageCustamize?.imageSizeControl?.maxWidth[
                            currentDeviceType
                          ] !== undefined &&
                          imageCustamize?.imageSizeControl?.height[
                            currentDeviceType
                          ] !== undefined
                            ? {
                                maxWidth: isNaN(
                                  +imageCustamize?.imageSizeControl.maxWidth[
                                    currentDeviceType
                                  ],
                                )
                                  ? imageCustamize?.imageSizeControl.maxWidth[
                                      currentDeviceType
                                    ]
                                  : `${+imageCustamize?.imageSizeControl.maxWidth[currentDeviceType]}px`,
                                height: isNaN(
                                  +imageCustamize?.imageSizeControl.height[
                                    currentDeviceType
                                  ],
                                )
                                  ? imageCustamize?.imageSizeControl.height[
                                      currentDeviceType
                                    ]
                                  : `${+imageCustamize?.imageSizeControl.height[currentDeviceType]}px`,
                              }
                            : {}),
                        }}
                        src={url}
                        alt={imageFile?.fileName}
                        className={`${imageCustamize?.imageBorder?.borderStyle?.[currentDeviceType]}`}
                        decoding="async"
                      />

                      {/* Badge at top-left corner, circular */}
                      {badgeCustomization?.showBadge && (
                        <span
                          className={`text-editor-content absolute top-0 left-0 px-2 py-1 rounded-full ${badgeCustomization?.badgeColor} text-white text-xs font-medium transform -translate-x-1 -translate-y-1 max-w-[110px] whitespace-normal break-words shadow-sm`}
                          style={{
                            backgroundColor:
                              badgeCustomization?.badgeColor?.color,
                          }}
                          dangerouslySetInnerHTML={{
                            __html: badgeCustomization?.badgeText,
                          }}
                        />
                      )}
                    </div>
                  </>
                )}
              </div>
              <div className="basis-9/10 flex flex-col gap-1 justify-center">
                {countDown?.showComponent?.[currentDeviceType] &&
                  !customLabels?.showLabels && (
                    <span
                      style={{
                        color: countDown?.textColor[currentDeviceType],
                        display: 'inline-flex',
                        gap: timerGap,
                        alignItems: 'center',
                      }}
                      className={`${countDown?.weight?.[currentDeviceType]} ${countDown?.fontSize?.[currentDeviceType]} text-center justify-center play-wright-hide`}>
                      {customCountDown?.addHours && (
                        <span>{hours < 10 ? `0${hours}` : hours}</span>
                      )}
                      {customCountDown?.addHours && <span>:</span>}
                      <span>{minutes < 10 ? `0${minutes}` : minutes}</span>
                      <span>:</span>
                      <span>{seconds < 10 ? `0${seconds}` : seconds}</span>
                      {customCountDown?.addMSeconds && (
                        <>
                          <span>:</span>
                          <span>
                            {milliseconds.toString().padStart(2, '0')}
                          </span>
                        </>
                      )}
                      <span
                        className="pl-1 text-editor-content"
                        dangerouslySetInnerHTML={{ __html: timerSuffix }}
                      />
                    </span>
                  )}
                {countDown?.showComponent?.[currentDeviceType] &&
                  customLabels?.showLabels && (
                    <div>
                      {/* Timer Display */}
                      <div
                        style={{
                          color: countDown?.textColor[currentDeviceType],
                          display: 'flex',
                          gap: timerGap,
                          alignItems: 'center',
                        }}
                        className={`${countDown?.weight?.[currentDeviceType]} ${countDown?.fontSize?.[currentDeviceType]} text-center justify-center play-wright-hide`}>
                        {customCountDown?.addHours && (
                          <span>{hours < 10 ? `0${hours}` : hours}</span>
                        )}
                        {customCountDown?.addHours && <span>:</span>}
                        <span>{minutes < 10 ? `0${minutes}` : minutes}</span>
                        <span>:</span>
                        <span>{seconds < 10 ? `0${seconds}` : seconds}</span>
                        {customCountDown?.addMSeconds && (
                          <>
                            <span>:</span>
                            <span>
                              {milliseconds.toString().padStart(2, '0')}
                            </span>
                          </>
                        )}
                      </div>

                      {/* Bottom Labels */}
                      <div
                        className={`mt-1 text-xs text-gray-500 justify-center text-center`}
                        style={{
                          display: 'flex',
                          gap: timerGap,
                          alignItems: 'center',
                        }}>
                        {customCountDown?.addHours && (
                          <span
                            className="text-editor-content mr-1"
                            dangerouslySetInnerHTML={{
                              __html: customLabels?.hours || 'Hours',
                            }}
                          />
                        )}
                        <span
                          className="text-editor-content mr-1"
                          dangerouslySetInnerHTML={{
                            __html: customLabels?.minutes || 'Minutes',
                          }}
                        />
                        <span
                          className="text-editor-content mr-1"
                          dangerouslySetInnerHTML={{
                            __html: customLabels?.seconds || 'Seconds',
                          }}
                        />
                        {customCountDown?.addMSeconds && (
                          <span
                            className="text-editor-content"
                            dangerouslySetInnerHTML={{
                              __html:
                                customLabels?.milliseconds || 'Milliseconds',
                            }}
                          />
                        )}
                      </div>
                    </div>
                  )}
                <div className="text-editor-content text-center">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: text,
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      );
    },
  };
};
